import React, { createRef, FC, InputHTMLAttributes, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { ILogin } from "../../../../utils/types";
import "./styleComponents.css";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  login: ILogin;
  handleChange(field: any, value: string): void;
}

const LoginPasswordInput: FC<InputProps> = ({
  login,
  handleChange,
  ...prop
}) => {
  const inputRef = createRef<HTMLInputElement>();
  const [previewPassword, setPreviewPassword] = useState(true);

  return (
    <div style={{position:'relative'}}>
      <input
        className="loginInput"
        placeholder="senha"
        type={previewPassword ? "password" : "text"}
        ref={inputRef}
        value={login.password}
        onChange={(e) => handleChange("password", e.target.value)}
        autoComplete="current-password"
        {...prop}
      />
      <FontAwesomeIcon onClick={() => setPreviewPassword(!previewPassword)} className="icon-eye" icon={previewPassword ? faEyeSlash : faEye}/>
    </div>
  );
};

export default LoginPasswordInput;
